import { isClient } from './device-utils';

const PAGE_PREFIX = 'page';

export const getCurrentPageNumber = (url?: string) => {
  const urlToTest = url || isClient() ? window.location.href : '';
  const currentPage = isClient() ? Number(urlToTest.match(`${PAGE_PREFIX}=([^&]*)`)?.[1]) : -1;
  return isNaN(currentPage) || currentPage <= 0 ? 1 : currentPage;
};

export const isValidUrl = (urlToCheck: string) => {
  let url: URL;
  try {
    url = new URL(urlToCheck);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};
